<template>
  <div>
    <NavBar v-if="sourceIsH5 && !showInsider" :narBarTitle="getTitle()" />

    <div v-if="!showInsider">
      <div class="content">
        <div class="metting-theme">
          <van-field
            v-model="topic"
            type="textarea"
            :placeholder="$t('添加活动标题')"
            clearable
            center
            rows="1"
            maxlength="50"
            class="theme"
            autosize
          />
        </div>

        <div class="informTime">
          <div class="informTime-top">
            <div class="date-box" @click="onDate">
              <div>{{ dayjs(date).format($t('M月D日 ddd')) }}</div>
            </div>
            <img src="@/assets/images/path.png" alt="" />
            <div class="date-box" @click="choseTime">
              <div>{{ startTime + '-' + endTime }}</div>
            </div>
            <div class="totalTime">
              {{ $t('共') }}
              <div class="allTime">{{ totalTime }}</div>
              {{ $t('分钟') }}
            </div>
          </div>
        </div>

        <div class="metting-theme">
          <van-field
            v-model="address"
            type="textarea"
            :placeholder="$t('添加地点')"
            clearable
            center
            rows="1"
            maxlength="50"
            class="theme"
            autosize
          />
        </div>

        <div class="confereeBox">
          <div class="confereeBox-top">
            <!-- <img src="@/assets/images/adduser.png" alt="" /> -->
            <div class="text">{{ $t('添加参与人') }}</div>
            <img
              src="@/assets/images/add.png"
              alt=""
              @click="showInsider = true"
            />
          </div>
          <div class="confereeBox-bottom" v-show="insiderList.length > 0">
            <InsiderBox
              v-for="(value, idx) in displayDepartmentList"
              :key="value.departmentId"
              :insiderName="value.departmentName"
              @click="delDepartment"
              :idx="idx"
              bColor="1"
              :id="value.departmentId"
              :repeat="value.repeat ? true : false"
            />
            <InsiderBox
              v-for="(value, idx) in displayStaffList"
              :key="value.id"
              :insiderName="value.name"
              @click="delInsiderList"
              bColor="2"
              :idx="idx"
              :id="value.id"
              :repeat="value.repeat ? true : false"
              :showClick="!(value.id == user.id && !replaceStaffChecked)"
            />
          </div>
        </div>

        <div class="repeat-box" v-show="isShowRepeat">
          <div class="repeatBox-top">
            <div class="repeat-text">
              {{ $t('提示：以下参会人存在参会时间重叠，请提前和参会人确认') }}
            </div>
          </div>
          <div class="repeat-info-wrap">
            <div v-for="item in repeatList" :key="item.userId">
              <div class="repeat-info">
                <div class="repeat-name">{{ item.userName }}</div>
                <div class="repeat-content">
                  <div v-for="(childItem, idx) in item.dateOverlaps" :key="idx">
                    <div>
                      {{ dayjs(childItem.beginTime).format('HH:mm') }}-{{
                        dayjs(childItem.endTime).format('HH:mm')
                      }}{{ $t('参与其他日程，重叠时间') }}{{ childItem.time
                      }}{{ $t('分钟') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="agree-btn">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            @click="submit"
            >{{ $t('确定') }}</van-button
          >
        </div>
      </div>

      <van-calendar
        v-model:show="dateShow"
        @confirm="dateConfirm"
        color="#1989fa"
        :default-date="date"
        :date="date"
      />

      <van-popup v-model="showStatus" position="bottom" safe-area-inset-bottom>
        <div>
          <van-checkbox-group v-model="result" class="timeList">
            <div style="position: absolute; top: 0; height: 66.6vh">
              <van-checkbox
                @click="viscousTime"
                :name="idx"
                class="timeListCard"
                icon-size="21px"
                v-for="(item, idx) in validTimeRange"
                :key="idx + 10000"
              >
                <div class="timeListRange">
                  {{ item.startTime }}~{{ item.endTime }}
                  <span class="extra">
                    <span v-if="item.conflict" style="color: #999">{{
                      $t('该时间已参加其他日程')
                    }}</span>
                    <span v-else-if="item.current" style="color: #009bff">{{
                      $t('当前时段')
                    }}</span>
                  </span>
                </div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="book-btn"
            @click="confirmTime"
            >{{ $t('确定') }}</van-button
          >
        </div>
      </van-popup>
    </div>

    <Address
      :userList="userList"
      v-else-if="showInsider"
      @back="toInform"
      @confirm="confirmSearch"
      :selectedList="insiderList"
    />
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import dayjs from 'dayjs'

import {
  getMeetingRoomConfig,
  dateOverlap,
  getUserList,
  createCalendar,
  updateCalendar,
  queryCalendarById,
  queryRepeatCalendar,
} from '@/services/api'

import {
  Field,
  Calendar,
  Cell,
  Checkbox,
  CheckboxGroup,
  Button,
  Popup,
  Toast,
} from 'vant'
import Address from '../../inform/address.vue'
import InsiderBox from '@/components/insiderBox'

Vue.use(Field)
Vue.use(Calendar)
Vue.use(Cell)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Toast)
export default {
  name: 'CreateSchedule',
  components: {
    NavBar,
    InsiderBox,
    Address,
  },
  data() {
    return {
      sourceIsH5: true,
      date: new Date(),

      dateShow: false,
      replaceStaffChecked: false,
      user: {},
      otherStaffData: [],
      meetingStatusList: [],
      showStatus: false,
      topic: '',
      startTime: '',
      endTime: '',
      rangeNum: '',
      timeUnit: 15,
      result: [],
      meetingRoomConfig: {},
      address: '',
      showInsider: false,
      displayDepartmentList: [],
      ifRepeat: true,
      totalInfo: [],
      displayStaffList: [],
      insiderList: [],
      repeatList: [],
      summaryName: '',
      summaryPeopleId: '',
      summaryResult: [],

      userList: [],
      withoutSelfList: [],
      info: {}, // 初始化日程信息
      isShowRepeat: false,

      wholeParticipantCalendarList: [],
    }
  },
  methods: {
    getTitle() {
      let title = ''
      if (this.info?.id) {
        title = this.$t('编辑日程')
      } else {
        title = this.$t('创建日程')
      }
      return title
    },
    async submit() {
      if (!this.startTime || !this.endTime) {
        Toast.fail(this.$t('时间段不能为空'))
        return
      }

      if (!this.topic) {
        Toast.fail(this.$t('活动标题不能为空'))
        return
      }

      if (this.address.length > 50) {
        Toast.fail(this.$t('地点不能超过50字'))
        return
      }

      if (this.topic.length > 50) {
        Toast.fail(this.$t('活动标题不能超过50字'))
        return
      }

      let peoplesId = []
      this.displayStaffList.forEach((v) => {
        peoplesId.push(v.id)
      })

      let params = {}
      params = {
        calendarTopic: this.topic,
        calendarStartTime: `${this.dateStr} ${this.startTime}:00`,
        calendarEndTime: `${this.dateStr} ${this.endTime}:00`,
        calendarAddress: this.address,
        calendarPeopleId: peoplesId.toString(),
        calendarStaff: `${this.user.id}`,
        companyId: this.user.companyId,
        id: this.info?.id ? this.info?.id : null,
      }
      if (this.info?.id) {
        const res = await updateCalendar(params)
        if (res.id) {
          this.$router.push({ path: '/scheduleInfo/', query: { id: res.id } })
          Toast.success(this.$t('日程编辑成功'))
        } else {
          Toast.fail(this.$t('日程编辑失败'))
        }
      } else {
        const res = await createCalendar(params)
        if (res.id) {
          this.$router.push({ path: '/scheduleInfo/', query: { id: res.id } })
          Toast.success(this.$t('日程创建成功'))
        } else {
          Toast.fail(this.$t('日程创建失败'))
        }
      }
      Toast.success(
        this.$t('日程{slot1}成功', {
          slot1: this.info?.id ? this.$t('编辑') : this.$t('创建'),
        })
      )
    },
    confirmSearch(data, displayData, total) {
      let arr = []
      if (data.length) {
        data.forEach((info) => arr.push(info.id))
        if (this.replaceStaffChecked && this.otherStaffData.length) {
          arr.push(this.otherStaffData[0].id)
        }
        this.checkRepeatt(arr.join(','))
      } else this.ifRepeat = false
      this.insiderList = [...data]
      this.summaryName =
        this.summaryResult.length > 1
          ? this.insiderList[this.summaryResult[0]].name +
            this.$t('等') +
            this.summaryResult.length +
            this.$t('人')
          : this.insiderList[this.summaryResult[0]].name
      this.displayDepartmentList = displayData.department
      this.displayStaffList = displayData.staff
      this.totalInfo = total
      this.showInsider = false

      this.getRepeatPeople()
    },
    // 获取重复参会人的信息
    async getRepeatPeople() {
      let staffIds = []
      this.displayStaffList?.forEach((v) => {
        // if (this.user.id != v.id) {
        staffIds.push(v.id)
        // }
      })

      const selectStartTime = `${this.dateStr} ${this.startTime}:00`
      const selectEndTime = `${this.dateStr} ${this.endTime}:00`

      let params = {
        companyId: this.user.companyId,
        // staffIds: [3808],
        beginTime: selectStartTime,
        endTime: selectEndTime,
        pageNum: 0,
        pageSize: 10000,
      }

      const res = await queryRepeatCalendar(params, staffIds)
      let repeatPeople = res?.results || []

      // 当用户编辑时，当前编辑的这条数据，不需要进入重复列表中展示
      repeatPeople = repeatPeople.filter((v) => v.id != this.info?.id)

      // 找到和选中员工有关联的日程
      let newList = []
      staffIds?.forEach((staff) => {
        const inCludeOne = repeatPeople.filter((v) =>
          v.calendarPeopleId.split(',').find((it) => it == staff)
        )

        if (inCludeOne.length) {
          newList.push({
            staffId: staff,
            data: inCludeOne,
          })
        }
      })

      let list = []
      newList.forEach((item) => {
        let dateOverlaps = []
        item?.data?.forEach((child) => {
          let beginTime = '',
            endTime = ''
          // if(dayjs(child.calendarStartTime).isBefore(selectStartTime)) {
          if (
            dayjs(child.calendarStartTime).valueOf() <
            dayjs(selectStartTime).valueOf()
          ) {
            // 历史日程的开始时间在选择的开始时间之前

            if (dayjs(child.calendarEndTime).valueOf() < dayjs(selectEndTime)) {
              // 历史日程的结束时间在选择的结束时间之前
              beginTime = selectStartTime
              endTime = child.calendarEndTime
            } else if (
              dayjs(child.calendarEndTime).valueOf() >=
              dayjs(selectEndTime).valueOf()
            ) {
              // 历史日程的结束时间在选择的结束时间之后
              beginTime = selectStartTime
              endTime = selectEndTime
            }
          } else if (
            dayjs(child.calendarStartTime).valueOf() >=
              dayjs(selectStartTime).valueOf() &&
            dayjs(child.calendarStartTime).valueOf() <=
              dayjs(selectEndTime).valueOf()
          ) {
            // 历史日程的开始时间在选择的开始时间之后，并且选择的结束时间之前

            if (
              dayjs(child.calendarEndTime).valueOf() <
              dayjs(selectEndTime).valueOf()
            ) {
              // 历史日程的结束时间在选择的结束时间之前
              beginTime = child.calendarStartTime
              endTime = child.calendarEndTime
            } else if (
              dayjs(child.calendarEndTime).valueOf() >=
              dayjs(selectEndTime).valueOf()
            ) {
              // 历史日程的结束时间在选择的结束时间之后
              beginTime = child.calendarStartTime
              endTime = selectEndTime
            }
          }

          if (beginTime !== endTime) {
            dateOverlaps.push({
              beginTime,
              endTime,
              time: dayjs(endTime).diff(beginTime, 'minute'),
            })
          }
        })

        if (dateOverlaps?.length) {
          list.push({
            userName: this.displayStaffList.find((v) => v.id === item.staffId)
              ?.name,
            userId: item.staffId,
            dateOverlaps,
          })
        }
      })

      // 去除相同的数据（产生原因：已有历史，会议10:30-11:30，日程10:30-11:30。现在创建11:15-11:50，重复的日程有会议和日程两条，且显示的数据一样，需要去掉重复）
      let noRepeatList = []
      list.forEach((it) => {
        const isInclude = noRepeatList.find(
          (v) =>
            v.userId == it.userId &&
            v.beginTime == it.beginTime &&
            v.endTime == it.endTime
        )
        if (!isInclude) {
          noRepeatList.push(it)
        }
      })

      if (list.length) {
        this.isShowRepeat = true
        this.repeatList = noRepeatList
      } else {
        this.isShowRepeat = false
        this.repeatList = []
      }
    },
    toInform() {
      this.showInsider = false
      // this.showOtherStaff = false
      // this.showRelation = false
    },
    delInsiderList(id, idx) {
      this.insiderList = this.insiderList.filter((item) => item.id != id)
      if (this.insiderList.length == 0) {
        this.summaryName = this.$t('无')
        this.summaryPeopleId = ''
        this.summaryResult = []
      } else {
        let summaryPeopleList = this.summaryPeopleId.split(',')
        let newResult = []
        let newIdList = []
        if (summaryPeopleList && summaryPeopleList.length) {
          summaryPeopleList.map((peopel) => {
            this.insiderList.map((item, index) => {
              if (peopel == item.id) {
                newIdList.push(item.id)
                newResult.push(index)
              }
            })
          })
          this.summaryResult = newResult
          this.summaryPeopleId = newIdList.join(',')
          this.summaryName =
            this.insiderList.length == newResult.length
              ? this.$t('所有人')
              : newResult.length == 1
              ? this.insiderList[newResult[0]].name
              : this.insiderList[newResult[0]].name +
                this.$t('等') +
                newResult.length +
                this.$t('人')
        }
      }
      this.displayStaffList.splice(idx, 1)
      if (this.insiderList.length) {
        let arr = []
        this.insiderList.forEach((info) => arr.push(info.id))
        if (this.replaceStaffChecked && this.otherStaffData.length) {
          arr.push(this.otherStaffData[0].id)
        }
        this.checkRepeatt(arr.join(','))
      } else this.ifRepeat = false

      this.getRepeatPeople()
    },
    delDepartment(id, idx) {
      this.AllDelete(this.totalInfo, id)
      this.displayDepartmentList.splice(idx, 1)
      if (this.displayDepartmentList.length > 0) {
        this.checkDepartment(this.insiderList)
      }
      if (this.insiderList.length) {
        let arr = []
        this.insiderList.forEach((info) => arr.push(info.id))
        if (this.replaceStaffChecked && this.otherStaffData.length) {
          arr.push(this.otherStaffData[0].id)
        }
        this.checkRepeatt(arr.join(','))
      } else this.ifRepeat = false
    },
    AllDelete(data, id) {
      data.forEach((item) => {
        if (id) {
          if (item.departmentId == id) {
            if (item.staffs && item.staffs.length > 0) {
              item.staffs.forEach((staffItem) =>
                this.delStaffIdList(staffItem.staffId)
              )
            }
            if (item.children.length > 0) {
              this.AllDelete(item.children)
            } else return
          } else {
            if (item.children.length > 0) {
              this.AllDelete(item.children, id)
            } else return
          }
        } else {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) =>
              this.delStaffIdList(staffItem.staffId)
            )
          }
          if (item.children.length > 0) {
            this.AllDelete(item.children)
          } else return
        }
      })
    },
    checkDepartment(data) {
      let arr = []
      data.forEach((item) => {
        if (item.departmentId.includes(',')) {
          let departmentIdList = item.departmentId.split(',')
          departmentIdList.forEach((id) => arr.push(id))
        } else arr.push(item.departmentId)
      })
      arr = Array.from(new Set(arr))
      let selectedIdList = data.map((item) => item.id)
      let department = []
      let includeDepartment = []
      arr.forEach((departmentId) => {
        let slectedNum = data.filter((item) => {
          if (item.departmentId.includes(',')) {
            let departmentIdList = item.departmentId.split(',')
            return departmentIdList.includes(departmentId)
          } else return item.departmentId == departmentId
        }).length
        let departmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          departmentId
        )
        if (
          departmentInfo.staffs &&
          slectedNum == departmentInfo.staffs.length
        ) {
          //判断是否最底层部门
          if (departmentInfo.children.length == 0) {
            let finalDepartment = this.checkSuperiorDepartment(
              departmentInfo,
              departmentId,
              arr
            )
            finalDepartment &&
              department.every(
                (item) => item.departmentId != finalDepartment.departmentId
              ) &&
              department.push(finalDepartment)
          } else {
            let ifAllChildSelected = []
            departmentInfo.children.forEach((childItem) => {
              let bl = this.checkSubordinateDepartment(
                childItem,
                selectedIdList
              )
              ifAllChildSelected.push(bl)
            })
            if (ifAllChildSelected.every((item) => item == true)) {
              let finalDepartment = this.checkSuperiorDepartment(
                departmentInfo,
                departmentId,
                arr
              )
              if (
                finalDepartment &&
                department.every(
                  (item) => item.departmentId != finalDepartment.departmentId
                )
              ) {
                department.push(finalDepartment)
                this.handlerFinalDepartment(finalDepartment, includeDepartment)
              }
            } else return
          }
        }
      })
      includeDepartment = Array.from(new Set(includeDepartment))
      department = department.filter((item) => {
        if (item.pid) {
          return (
            !includeDepartment.includes(item.pid) &&
            !includeDepartment.includes(item.departmentId)
          )
        } else return true
      })
      this.displayDepartmentList = []
      this.displayStaffList = this.insiderList
    },
    async checkRepeatt(staffIds) {
      let beginTime = this.dateStr + ' ' + this.startTime + ':00'
      let endTime = this.dateStr + ' ' + this.endTime + ':00'
      const res = await dateOverlap({
        staffIds,
        beginTime,
        endTime,
      })
      if (res.length) {
        res.forEach((item) => {
          item.dateOverlaps.forEach((meetingInfo) => {
            if (
              dayjs(meetingInfo.beginTime).valueOf() >=
                dayjs(beginTime).valueOf() &&
              dayjs(meetingInfo.endTime).valueOf() <= dayjs(endTime).valueOf()
            ) {
              meetingInfo.time =
                (dayjs(meetingInfo.endTime).valueOf() -
                  dayjs(meetingInfo.beginTime).valueOf()) /
                (1000 * 60)
              return
            }
            if (
              dayjs(meetingInfo.beginTime).valueOf() >=
                dayjs(beginTime).valueOf() &&
              dayjs(meetingInfo.endTime).valueOf() >= dayjs(endTime).valueOf()
            ) {
              meetingInfo.time =
                (dayjs(endTime).valueOf() -
                  dayjs(meetingInfo.beginTime).valueOf()) /
                (1000 * 60)
              return
            }
            if (
              dayjs(meetingInfo.beginTime).valueOf() <=
                dayjs(beginTime).valueOf() &&
              dayjs(meetingInfo.endTime).valueOf() <= dayjs(endTime).valueOf()
            ) {
              meetingInfo.time =
                (dayjs(meetingInfo.endTime).valueOf() -
                  dayjs(beginTime).valueOf()) /
                (1000 * 60)
              return
            }
          })
        })
        // this.repeatList = res
        // this.ifRepeat = true
      } else {
        // this.ifRepeat = false
        // this.repeatList = []
      }
    },
    delStaffIdList(id) {
      this.insiderList = this.insiderList.filter((item) => item.id != id)
      if (this.insiderList.length == 0) {
        this.summaryName = this.$t('无')
        this.summaryPeopleId = ''
        this.summaryResult = []
      } else {
        let summaryPeopleList = this.summaryPeopleId.split(',')
        let newResult = []
        let newIdList = []
        if (summaryPeopleList && summaryPeopleList.length) {
          summaryPeopleList.map((peopel) => {
            this.insiderList.map((item, index) => {
              if (peopel == item.id) {
                newIdList.push(item.id)
                newResult.push(index)
              }
            })
          })
          this.summaryResult = newResult
          this.summaryPeopleId = newIdList.join(',')
          this.summaryName =
            this.insiderList == newResult.length
              ? this.$t('所有人')
              : newResult.length == 1
              ? this.insiderList[newResult[0]].name
              : this.insiderList[newResult[0]].name +
                this.$t('等') +
                newResult.length +
                this.$t('人')
        }
      }
    },
    handlerFinalDepartment(data, idList) {
      if (data.children.length > 0) {
        data.children.forEach((item) => {
          idList.push(item.departmentId)
          if (item.children.length > 0) {
            this.handlerFinalDepartment(item, idList)
          }
        })
      }
    },
    checkTotalStaffCount(data, id) {
      let selectedData = {}
      data.some((item) => {
        if (item.departmentId == id) {
          selectedData = item
          return true
        } else {
          if (item.children && item.children.length > 0) {
            let returnData = this.checkTotalStaffCount(item.children, id)
            returnData.staffs && (selectedData = returnData)
          } else return
        }
      })
      return selectedData
    },
    //下级部门查询
    checkSubordinateDepartment(data, selectedIdList) {
      let bl = true
      if (data.staffs && data.staffs.length > 0) {
        bl = data.staffs.every((childStaff) =>
          selectedIdList.includes(childStaff.staffId)
        )
      }
      if (bl && data.children.length > 0) {
        data.children.forEach((item) => {
          bl = this.checkSubordinateDepartment(item, selectedIdList)
        })
      }
      return bl
    },
    //上级部门查询
    checkSuperiorDepartment(data, departmentId, arr) {
      let response = null
      if (data.pid) {
        let pidDepartmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          data.pid
        )
        let slectedNum = this.insiderList.filter(
          (item) => item.departmentId == pidDepartmentInfo.departmentId
        ).length
        if (
          slectedNum + data.totalStaffCount ==
          pidDepartmentInfo.totalStaffCount
        ) {
          let childData = pidDepartmentInfo.children.filter(
            (item) => item.departmentId == departmentId
          )[0]
          response = this.checkSuperiorDepartment(
            pidDepartmentInfo,
            pidDepartmentInfo.departmentId,
            arr,
            childData
          )
        } else {
          response = data
          return response
        }
      } else {
        response = data
        return response
      }
      return response
    },
    onDate() {
      this.dateShow = true
    },
    async choseTime() {
      const staffIds = this.displayStaffList?.map((v) => v.id)

      const params = {
        companyId: this.user.companyId,
        beginTime: this.dateStr + ' 00:00:00',
        endTime: this.dateStr + ' 24:00:00',
        pageNum: 0,
        pageSize: 10000,
      }

      this.wholeParticipantCalendarList =
        (await queryRepeatCalendar(params, staffIds))?.results ?? []

      this.showStatus = true
    },
    dateConfirm(value) {
      this.dateShow = false
      this.date = value
      const nowDate = dayjs().format('YYYY-MM-DD')
      if (
        dayjs(value).isSame(dayjs(), 'day') &&
        dayjs(`${nowDate} ${this.startTime}`).isBefore(
          dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
        )
      ) {
        this.result = []
        this.rangeNum = 0
        this.startTime = ''
        this.endTime = ''
        Toast.fail(this.$t('时间段不可为无效时间段，请重新选择'))
      } else {
        const startIdx = this.validTimeRange.findIndex(
          (v) => v.startTime == this.startTime
        )
        const endIdx = this.validTimeRange.findIndex(
          (v) => v.endTime == this.endTime
        )

        this.result = []
        if (startIdx < 0 || endIdx < 0) return
        // 补全startIdx, endIdx之间的值
        for (let index = startIdx; index <= endIdx; index++) {
          this.result = this.result.concat(index)
        }
      }
    },

    viscousTime() {
      let min = Infinity,
        max = -Infinity
      this.result?.forEach((i) => {
        if (i < min) min = i
        if (i > max) max = i
      })

      this.result = []
      for (let i = min; i <= max; i++) {
        this.result = this.result.concat(i)
      }
    },
    hour2num(str) {
      return parseInt(str?.slice(0, 2) ?? 0)
    },
    // 获取会时间
    async getMeetingTimeRange(developerId) {
      try {
        const res = await getMeetingRoomConfig({
          developerId,
        })
        this.timeUnit = res.timeUnit

        const num =
          dayjs('24:00', 'HH:mm').diff(dayjs('00:00', 'HH:mm'), 'minute') /
          this.timeUnit
        this.meetingStatusList = Array(num)
          .fill(Object.create(null))
          .map((_, i) => ({
            startTime: dayjs('00:00', 'HH:mm')
              .add(i * this.timeUnit, 'minute')
              .format('HH:mm'),
            endTime: dayjs('00:00', 'HH:mm')
              .add((i + 1) * this.timeUnit, 'minute')
              .format('HH:mm'),
          }))

        if (this.meetingStatusList?.[num - 1].endTime === '00:00') {
          this.meetingStatusList[num - 1].endTime = '24:00'
        }
      } catch (error) {
        console.log(error.response.data.message)
      }
    },
    confirmTime() {
      if (this.result.length == 0) {
        Toast.fail(this.$t('预约时间段不能为空'))
        return
      }
      this.result.sort(function (a, b) {
        return a - b
      })
      let continuous = this.result.every((val, idx) => {
        if (idx == this.result.length - 1) {
          return true
        } else {
          return this.result[idx + 1] - val == 1
        }
      })
      if (continuous) {
        this.startTime = this.validTimeRange[this.result[0]].startTime
        this.endTime =
          this.validTimeRange[this.result[this.result.length - 1]].endTime
        this.rangeNum = this.result.length

        this.ifRepeat = false
        this.showStatus = false

        this.getRepeatPeople()
      } else {
        Toast.fail(this.$t('预约时间段之间需连续'))
      }
    },
    async getUsers(companyId) {
      try {
        const res = await getUserList({ companyId })
        let arr = [...res]
        this.userList = arr
        this.withoutSelfList = this.userList.filter((item) => {
          return item.id != this.user.id
        })
        let tmp = this.userList.filter((item) => {
          return item.id == this.user.id
        })
        this.insiderList = tmp
        this.summaryName =
          this.summaryResult.length > 1
            ? this.insiderList[this.summaryResult[0]].name +
              this.$t('等') +
              this.summaryResult.length +
              this.$t('人')
            : this.insiderList[this.summaryResult[0]].name
        this.displayStaffList = tmp

        // 获取到用户保存过的日程
        const scheduleInfoId = this.$route.query?.id
        if (scheduleInfoId) {
          this.init(scheduleInfoId)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async init(id) {
      // this.choseTime()

      const res = await queryCalendarById({ id })
      this.info = res

      if (res) {
        this.topic = res?.calendarTopic ?? ''
        this.date = res?.calendarStartTime
          ? new Date(
              dayjs(res.calendarStartTime, 'YYYY-MM-DD HH:mm:ss').valueOf()
            )
          : new Date()
        console.log('init this.date', this.date)
        this.address = res?.calendarAddress ?? ''
        this.startTime = res?.calendarStartTime
          ? dayjs(res.calendarStartTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
          : ''
        this.endTime = res?.calendarEndTime
          ? dayjs(res.calendarEndTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
          : ''

        // const startIdx = this.validTimeRange.findIndex(v => v.startTime == this.startTime)
        // const endIdx = this.validTimeRange.findIndex(v => v.endTime == this.endTime)
        this.validTimeRange.forEach((v, idx) => {
          let startTime = this.dateStr + ' ' + v.startTime + ':00'
          let endTime = this.dateStr + ' ' + v.endTime + ':00'
          if (
            (dayjs(startTime).valueOf() >=
              dayjs(res?.calendarStartTime).valueOf() &&
              dayjs(endTime).valueOf() <=
                dayjs(res?.calendarEndTime).valueOf()) ||
            (dayjs(res?.calendarStartTime).isBetween(
              dayjs(startTime),
              dayjs(endTime),
              'minutes',
              '[]'
            ) &&
              dayjs(endTime).valueOf() !=
                dayjs(res?.calendarStartTime).valueOf()) ||
            (dayjs(res?.calendarEndTime).isBetween(
              dayjs(startTime),
              dayjs(endTime),
              'minutes',
              '[]'
            ) &&
              dayjs(startTime).valueOf() !=
                dayjs(res?.calendarEndTime).valueOf())
          ) {
            this.result.push(idx)
          }
        })
        // 补全startIdx, endIdx之间的值
        // for (let index = startIdx; index <= endIdx; index++) {
        //   this.result = this.result.concat(index)
        // }

        // 重新计算总分钟
        this.rangeNum = this.result.length

        // 更新参与人的值
        let newUserList = []
        const peoples = res?.calendarPeopleId
          ? res.calendarPeopleId.split(',')
          : []
        peoples.forEach((staffId) => {
          const staff = this.userList.find((u) => u.id == staffId)

          if (staff) {
            newUserList.push(staff)
          }
        })
        this.insiderList = newUserList
        this.displayStaffList = newUserList
      }

      // 进入到编辑时，需要默认校验一下是否有重复
      if (this.info?.id) {
        this.getRepeatPeople()
      }
    },
  },
  computed: {
    totalTime() {
      return this.rangeNum * this.timeUnit
    },
    dateStr() {
      return dayjs(this.date).format('YYYY-MM-DD')
    },
    validTimeRange() {
      return this.meetingStatusList
        ?.filter((v) => dayjs(this.dateStr + v.endTime).isAfter(dayjs()))
        .map((v) => ({
          ...v,
          conflict: this.wholeParticipantCalendarList?.some((s) =>
            dayjs(this.dateStr + v.endTime).isBetween(
              dayjs(s.calendarStartTime),
              dayjs(s.calendarEndTime),
              'minutes',
              '(]'
            )
          ),
          current: dayjs().isBetween(
            dayjs(this.dateStr + v.startTime),
            dayjs(this.dateStr + v.endTime),
            'minutes',
            '[]'
          ),
        }))
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.summaryResult = [0]

    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
    this.getMeetingTimeRange(this.user.companyId)
    this.getUsers(this.user.companyId)
    this.summaryPeopleId = this.user.id + ''
  },
}
</script>
<style lang="less" scoped>
.content {
  background-color: #ffffff;
  padding-bottom: 20px;

  .metting-theme {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 13px 16px;
    border-bottom: 1px solid #ececec;

    /deep/.van-cell {
      padding: 0;
    }

    /deep/.van-field__control {
      font-size: 16px;
      color: #333333;
    }
  }
}

.informTime {
  margin-top: 12px;
  height: 116px;
  background: #fefffe;
  padding: 0px 16px;

  .informTime-top {
    display: flex;
    align-items: center;
    height: 69px;
    border-bottom: 1px solid #ededed;
    justify-content: space-between;
    font-size: 14px;

    .date-box {
      width: 92px;
      line-height: 24px;
    }

    img {
      height: 45px;
    }

    .totalTime {
      height: 100%;
      width: 80px;
      padding-left: 14px;
      display: flex;
      align-items: center;
      border-left: 1px solid #ededed;
      text-align: center;

      .allTime {
        color: #009bff;
      }
    }
  }
}

.timeList {
  position: relative;
  height: 424px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.confereeBox {
  // margin-bottom: 12px;
  // margin-top: 12px;
  border-bottom: 1px solid #ececec;
  width: 100%;

  .confereeBox-top {
    padding: 17px 16px;
    // height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      flex: 1;
      font-weight: 600;
      font-size: 20px;
      color: #202020;
    }

    img {
      height: 20px;
    }
  }

  .confereeBox-bottom {
    padding: 0 16px;
    display: flex;
    flex-wrap: wrap;
    min-height: 100px;
    overflow: auto;
    background: #fefffe;
  }

  .outsiderWrap {
    min-height: 100px;
    overflow: auto;
    background: #ffffff;
  }

  .outsiderBox {
    margin: 10px 10px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    background: #f4f4f4;

    .outsiderMsg {
      display: flex;
      font-size: 14px;
      align-items: center;
      background: #f4f4f4;
      border-radius: 2px;
      // border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .outsiderName {
      height: 40px;
      width: 96px;
      line-height: 40px;
      text-align: center;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .outsiderEMail {
      padding-left: 23px;
      width: 221px;
    }

    .outsiderDel {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f4f4f4;
      width: 40px;

      img {
        height: 8px;
        width: 8px;
      }
    }
  }
}

.agree-btn {
  padding: 0 10px;
  margin-top: 20px;
}

.repeat-box {
  margin-top: 12px;
  background: #fefffe;
  margin-bottom: 20px;

  .repeatBox-top {
    padding-top: 9px;
    height: 37px;
    border-bottom: 1px solid #ededed;
    padding-left: 16px;

    .repeat-text {
      font-size: 12px;
      color: #ff3b30;
      line-height: 16px;
    }
  }

  .repeat-info-wrap {
    padding-left: 16px;
    padding-right: 10px;

    .repeat-info {
      // display: flex;
      border-bottom: 1px solid #ededed;
      padding-top: 15px;
      padding-bottom: 16px;

      .repeat-name {
        width: 75px;
        font-size: 16px;
        color: #666666;
        line-height: 24px;
      }

      .repeat-content {
        font-size: 14px;
        color: #999999;
        line-height: 24px;

        > div {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
